import script from "./ArticlesSharePage.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticlesSharePage.vue?vue&type=script&setup=true&lang=js"

import "./ArticlesSharePage.vue?vue&type=style&index=0&id=2f6a267d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f6a267d"]])

export default __exports__